import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { get, map } from "lodash"
import { withTranslation } from "react-i18next"

//i18n
import i18n from "../../../i18n"
import languages from "common/languages"

const LanguageDropdown = () => {
  // Declare a new state variable, which we'll call "menu"
  const [selectedLang, setSelectedLang] = useState("")
  const [menu, setMenu] = useState(false)

  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE")
    setSelectedLang(currentLanguage)
  }, [])

  const changeLanguageAction = lang => {
    //set language as i18n
    i18n.changeLanguage(lang)
    localStorage.setItem("I18N_LANGUAGE", lang)
    setSelectedLang(lang)
  }

  const toggle = () => {
    setMenu(!menu)
  }

  
  const [isRTL, setIsRTL] = useState(false);
  
  useEffect(() => {
    if (isRTL) {
      document.documentElement.setAttribute('dir', 'rtl');
      document.body.classList.add('rtl');
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
      document.body.classList.remove('rtl');
    }
  }, [isRTL]);

  const toggleDirection = () => {
    setIsRTL(!isRTL);
  };

  const toggleBack = ()=>{
    setIsRTL(false)
  }

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className=" d-md-block ms-2">
        <DropdownToggle className="btn header-item waves-effect text-dark" tag="button">
          <img
            src={get(languages, `${selectedLang}.flag`)}
            alt="Zain"
            height="16"
            className="me-2"
          />
          {" "}{get(languages, `${selectedLang}.label`)}
          {" "}<span className="mdi mdi-chevron-down text-dark"></span>
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          {map(Object.keys(languages), key => (
            <DropdownItem
              key={key}
              onClick={() =>{key === "om" ? toggleDirection():toggleBack(); changeLanguageAction(key);}}
              className={`notify-item ${selectedLang === key ? "active " : "none"
                }`}
              
            >
              <img
                src={get(languages, `${key}.flag`)}
                alt="Zain"
                className="me-2"
                height="12"
              />
              <span className="align-middle">
                {get(languages, `${key}.label`)}
              </span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default withTranslation()(LanguageDropdown)
